import { resolveId } from '@wix/communities-blog-client-common';

import { createPromisifiedAction } from '../actions-promisifier/create-promisified-action';
import { setIsSaving } from '../store/is-saving/is-saving-actions';
import { publishPostAndNavigate } from './publish-post';
import { savePostDraft } from './save-post-draft';

const saveAndPublishPost = (values) => (dispatch) => {
  dispatch(setIsSaving(true));
  return dispatch(savePostDraft(values)).then((post) =>
    dispatch(publishPostAndNavigate(resolveId(post))),
  );
};

export const saveAndPublishPostPromisified = createPromisifiedAction(
  saveAndPublishPost,
  (data) => data,
  (response) => response.status,
);
